import { isTruncated, truncateText } from '../../../utils/truncateText';
import './NudosHoverText.scss';

/**
 * @property {string} text - Required, the text that will be shwon when hovered
 * @property {number} charactersLimit - Required, the limit of characters after which the text will be truncated with ellipsis
 * @property {boolean} onlyIfTruncated - Optional, a boolean indicating if the hover should only applied if the text is truncated. Default is FALSE.
 * @property {string} customClassName -Optional, the className to personalize the styles of the text element
 */
const NudosHoverText = ({
  text,
  charactersLimit,
  onlyIfTruncated,
  customClassName,
  customTextHoverClassName = '',
  maxHoverWidth,
  ...rest
}: INudosHoverTextProps) => {
  const textHoverClassName = `textHover ${customTextHoverClassName}`;
  return (
    <div className={`nudosHoverText ${customClassName}`} {...rest}>
      {truncateText(text, charactersLimit)}
      {onlyIfTruncated && isTruncated(text, charactersLimit) && (
        <div 
          className={textHoverClassName} 
          style={maxHoverWidth ? { maxWidth: maxHoverWidth, whiteSpace: 'normal', height: 'auto', minHeight: '2rem' } : undefined}
        >
          {text}
        </div>
      )}
      {!onlyIfTruncated && (
        <div 
          className={textHoverClassName} 
          style={maxHoverWidth ? { maxWidth: maxHoverWidth, whiteSpace: 'normal', height: 'auto', minHeight: '2rem' } : undefined}
        >
          {text}
        </div>
      )}
    </div>
  );
};

export default NudosHoverText;

interface INudosHoverTextProps extends React.HTMLAttributes<HTMLDivElement> {
  text: string;
  charactersLimit: number;
  onlyIfTruncated?: boolean;
  customClassName?: string;
  customTextHoverClassName?: string;
  maxHoverWidth?: string; // Ejemplo: '200px', '15rem', etc.
}
